export default "__VITE_ASSET__CEgI$yrl__"